module.exports = __webpack_public_path__ + "img/ph_qrcode_whatsapp.5b7040b.png";